import { makeStyles, colors } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  chip: {
    borderRadius: 4,
    color: theme.palette.white,
    fontWeight: 700,
    height: 21,
    textTransform: 'uppercase',
  },
  active: {
    backgroundColor: colors.green[800],
  },
  inactive: {
    backgroundColor: colors.blueGrey[800],
  },
  draft: {
    backgroundColor: colors.blue[800],
  },
  dponet: {
    backgroundColor: colors.blue[700],
  },
  dpoEasy: {
    backgroundColor: colors.purple[700],
  },
  advisor: {
    backgroundColor: colors.orange[700],
  },
}))

export default styles
